<template>
    <div>
        <v-app>
            <v-card :loading="loading" elevation="2" outlined class="p-3">
                <v-card-title class="justify-content-between">
                    <div>
                    </div>
                    <v-autocomplete label="نوع سفارش"
                                    @change="changeAccess($event)"
                                    :items="access"
                                    v-model="formsType"
                                    item-text="name"
                                    item-value="value"
                                    dense
                                    outlined
                    >
                    </v-autocomplete>
                    <div class="mb-7">
                        <v-btn class="btn-search"
                               @click="tableProps = tablePropsDefault; getSites()">
                            <v-icon>mdi-refresh</v-icon>
                            بارگذاری مجدد
                        </v-btn>
                    </div>

                </v-card-title>
                <v-divider/>

                <div class="row">

                    <div class="col-md-12 p-5">

                        <template>
                            <v-row justify="center">
                                <custom-popup v-model="showDialog"
                                              max-width="900"
                                              hide-overlay
                                              :cons="cons"
                                              transition="dialog-bottom-transition"
                                              hide-confirm>
                                    <v-card class="px-5">

                                        <officeinfos :admin="true"
                                                     v-if="(formsType==='admin/form/headers' && showDialog) || (type==='headers' && showDialog)"
                                                     :url="url"
                                                     :archives="infos"
                                                     :modal="()=>{this.showDialog=false}"
                                                     :reqAgain="()=>{this.reloadTable(url)}" :id="myID"></officeinfos>

                                        <visit-infos :archives="infos"
                                                     v-if="(formsType==='admin/form/visitCards' && showDialog) || (type==='visit_cards' && showDialog)"
                                                     :url="url"
                                                     :modal="()=>{this.showDialog=false}"
                                                     :reqAgain="()=>{this.reloadTable(url)}" :id="myID"></visit-infos>

                                        <tracet-informations :archives="infos"
                                                             v-if="(formsType==='admin/form/tracet' && showDialog) || (type==='tracet' && showDialog)"
                                                             :admin="true"
                                                             :url="url" :modal="()=>{this.showDialog=false}"
                                                             :reqAgain="()=>{this.reloadTable(url)}"
                                                             :id="myID"></tracet-informations>

                                        <set-informations :archives="infos"
                                                          v-if="(formsType==='admin/form/officeSet' && showDialog) || (type==='office_sets' && showDialog)"
                                                          :admin="true"
                                                          :url="url"
                                                          :modal="()=>{this.showDialog=false}"
                                                          :reqAgain="()=>{this.reloadTable(url)}"
                                                          :id="myID"></set-informations>

                                        <banner-information :archives="infos"
                                                            v-if="(formsType==='admin/form/banner' && showDialog) || (type==='banner' && showDialog)"
                                                            :url="url"
                                                            :modal="()=>{this.showDialog=false}"
                                                            :reqAgain="()=>{this.reloadTable(url)}"
                                                            :id="myID"></banner-information>

                                        <poster-informations :archives="infos"
                                                             v-if="(formsType==='admin/form/poster' && showDialog) || (type==='poster' && showDialog)"
                                                             :admin="true"
                                                             :url="url"
                                                             :modal="()=>{this.showDialog=false}"
                                                             :reqAgain="()=>{this.reloadTable(url)}"
                                                             :id="myID"></poster-informations>

                                        <bro-informations :archives="infos"
                                                          v-if="(formsType==='admin/form/brochure' && showDialog) || (type==='brochure' && showDialog)"
                                                          :admin="true"
                                                          :url="url"
                                                          :modal="()=>{this.showDialog=false}"
                                                          :reqAgain="()=>{this.reloadTable(url)}"
                                                          :id="myID"></bro-informations>

                                        <informations :archives="infos"
                                                      v-if="(formsType==='admin/form/logo' && showDialog) || (type==='logo' && showDialog)"
                                                      :url="url"
                                                      :modal="()=>{this.showDialog=false}"
                                                      :reqAgain="()=>{this.reloadTable(url)}" :admin="true"
                                                      :id="myID"></informations>
                                    </v-card>
                                </custom-popup>
                            </v-row>
                        </template>

                        <template>
                            <v-row justify="center">
                                <custom-popup v-model="myDia"
                                              max-width="900"
                                              hide-overlay
                                              :cons="cons"
                                              transition="dialog-bottom-transition"
                                              hide-confirm>
                                    <v-card class="px-5">
                                        <pay-page v-if="myDia" :mdel="mdel" :admin="true"
                                                  :modal="()=>{this.myDia=false}"
                                                  :reqAgain="()=>{this.reloadTable(url)}" :archives="infos"></pay-page>
                                    </v-card>
                                </custom-popup>

                            </v-row>
                        </template>

                        <terminal-table class="col-12" :currentPage="userInfo.current_page"
                                        :perPage="userInfo.per_page" v-if="isMobile" :getData="getSites"
                                        :pageCount="userInfo.last_page"
                                        :options="tableProps" :datas="userInfo" :headers="columns"></terminal-table>

                        <data-table v-else :data="userInfo" :columns="columns"
                                    :translate="translate"
                                    :per-page="[10, 25, 50, 100]"
                                    @on-table-props-changed="reloadTable">
                            <div slot="filters" slot-scope="{ tableFilters, perPage }">
                                <div class="row mb-2">
                                    <div class="col-md-3">
                                        <select class="form-control pr-3"
                                                v-model="tableFilters.length">
                                            <option :key="page" v-for="page in perPage">
                                                {{ page }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-md-3">
                                    </div>
                                    <div class="col-md-3">
                                    </div>

                                    <div class="col-md-3" v-if="formsType!=='admin/form/all' ">
                                        <v-text-field outlined dense label="جست و جو"
                                                      class="pl-3"
                                                      @change="(i) => (tableFilters.search = i)">
                                        </v-text-field>
                                    </div>
                                </div>
                            </div>

                        </data-table>

                    </div>
                </div>
            </v-card>
        </v-app>

    </div>
</template>

<script>
import actionButton from '@/view/content/button'
import Informations from "./informations";
import PayPage from "../site/payPage";
import siteStatusButton from "@/view/pages/site/siteStatusButton";
import Officeinfos from "@/view/pages/site/office/officeInfos";
import VisitInfos from "@/view/pages/site/visitInfos";
import TracetInfos from "@/view/pages/site/tracet/tracetInfo";
import TracetInformations from "@/view/pages/site/tracet/tracetInfo";
import SetInformations from "@/view/pages/components/setInformation";
import BannerInformation from "@/view/pages/site/banner/components/bannerInformation";
import CustomPopup from "@/core/plugins/TitleRibbon/plugins/popup/customPopup";
import PosterInformations from "@/view/pages/site/poster/posterInformations";
import BroInformations from "@/view/pages/site/brochur/broInformations";

export default {
    name: "requestsList",
    components: {
        BroInformations,
        PosterInformations,
        CustomPopup,
        BannerInformation,
        SetInformations, TracetInformations, TracetInfos, VisitInfos, Officeinfos, PayPage, Informations
    },
    data() {
        return {
            dialogPayment: false,
            myDia: false,
            myID: '',
            showDialog: false,
            cons: {
                title: 'اطلاعات درخواست'
            },
            payDialogInfo: {},
            payableTransaction: null,
            formsType: 'admin/form/all',
            selectedRows: [],
            access: [
                {name: 'همه', value: 'admin/form/all'},
                {name: 'سربرگ', value: 'admin/form/headers'},
                {name: 'لوگو', value: 'admin/form/logo'},
                {name: 'کارت ویزیت', value: 'admin/form/visitCards'},
                {name: 'طراحی تراکت', value: 'admin/form/tracet'},
                {name: 'طراحی ست اداری', value: 'admin/form/officeSet'},
                {name: 'طراحی بنر', value: 'admin/form/banner'},
                {name: 'طراحی پوستر', value: 'admin/form/poster'},
                {name: 'طراحی بروشور', value: 'admin/form/brochure'},

            ],
            paymentLoading: false,
            errors: [],
            loading: false,
            type: '',
            errorMsg: '',
            userWallet: [],
            dialogInfo: null,
            tab: null,
            typeList: {
                'headers': 'سربرگ',
                'logo': 'لوگو',
                'visit_cards': 'کارت ویزیت',
                'tracet': 'نراکت',
                'office_sets': 'ست اداری',
                'banner': 'بنر',
                'poster': 'پوستر',
                'brochure': 'بروشور',
            },
            translate: {
                nextButton: 'بعدی',
                previousButton: 'قبلی',
                rowsPerPageText: 'تعداد در صفحه',
                noDataText: 'داده ای برای نمایش وجود ندارد',
                placeholderSearch: 'جستجو',
            },
            url: 'admin/form/all',
            userInfo: {},
            tableProps: {
                search: '',
                length: 10,
                column: 'id',
                dir: 'desc',
                page: 1,
            },
            tablePropsDefault: {
                search: '',
                length: 10,
                column: 'id',
                dir: 'desc',
            },
            columns: [
                {
                    label: 'ردیف',
                    transform: (val) => {
                        let row = this.userInfo.current_page - 1;
                        row = row * this.userInfo.per_page;
                        return row + val.row + 1;
                    },
                },
                {
                    label: 'شناسه',
                    name: 'id',
                    orderable: true,
                    colStyle: 'width: 100px;'
                },
                {
                    label: 'نام کاربر',
                    name: 'id',
                    transform(val) {
                        if (val?.data?.user) {
                            return val?.data?.user?.name + ' ' + val?.data?.user?.lastName
                        } else return ' - '
                    },
                    orderable: true,
                },
                {
                    label: 'نوع سفارش',
                    name: 'type',
                    transform(val) {
                        const a = {
                            'headers': 'سربرگ',
                            'logo': 'لوگو',
                            'visit_cards': 'کارت ویزیت',
                            'tracet': 'تراکت',
                            'office_sets': 'ست اداری',
                            'banner': 'بنر',
                            'poster': 'پوستر',
                            'brochure': 'بروشور',
                        }
                        return a[val.data.type]
                    },
                    orderable: true,
                },
                {
                    label: 'نام مجموعه',
                    name: 'organizationName',
                    orderable: true,
                },
                {
                    label: 'نام برند',
                    name: 'brandName',
                    orderable: true,
                },
                {
                    label: 'شعار برند',
                    name: 'brandSlogan',
                    searchable: true,
                    // transform: (value, data) => {
                    //   return value.data.location ? `${value.data.location[0]} , ${value.data.location[1]}` : 'ندارد'
                    // }
                },
                {
                    label: 'زمان تحویل',
                    name: 'deliveryTime',
                    searchable: true,
                    orderable: true,
                    transform: (value, data) => {
                        return this.jalalian(value.data.deliveryTime)
                    }
                },
                {
                    name: 'status',
                    primary: true,
                    label: 'وضعیت',
                    transform(val) {
                        let text = val.data.status;
                        let color = 'light'

                        switch (val.data.status) {
                            case "pending":
                                text = 'در انتظار تایید';
                                color = 'warning'
                                break;

                            case "accept":
                                text = 'در انتظار پرداخت';
                                color = 'info'
                                break

                            case "reject":
                                text = 'رد شده';
                                color = 'danger'
                                break

                            case "disable":
                                text = 'مسدود';
                                color = 'light'
                                break

                            case "paid":
                                text = 'پرداخت شده';
                                color = 'success'
                                break
                        }

                        return `<span class="badge badge-${color}">${text}</span>`;
                    },
                    event: 'action',
                },
                {
                    label: 'مدیریت',
                    name: 'actions',
                    component: actionButton,
                    handler: this.actions,
                    event: 'action',
                    permission_prefix: 'user_',
                    meta: {
                        buttons: [
                            {
                                name: "show",
                                label: "مشاهده اطلاعات",
                                icon: "eye",
                                class: 'btn-outline-warning',
                                type: 'show',
                                action: this.actions,
                                permission: "user_access"
                            },
                            {
                                name: "Pay",
                                label: "پرداخت اقساط",
                                icon: "dollar-sign",
                                type: 'show',
                                class: 'btn-outline-info',
                                action: this.actions,
                                condition: this.buttonsCondition
                            },
                        ]
                    }
                },
            ],
            statusBadge: '',
            mdel: '',
            infos: {},
            userValid: true,
            isRejected: false,
            isPending: false,
            userInfoGot: false,

        }
    },
    mounted() {
        this.getSites('admin/form/all');
    },
    methods: {
        changeAccess(URL) {
            this.url = URL
            this.getSites(URL)
        },
        buttonsCondition(status) {
            return [
                "pending",
                "reject"
            ].indexOf(status) <= -1;
        },
        Pay(data) {
            if (this.formsType === 'admin/form/headers') {
                this.mdel = 'headers';
            } else if (this.formsType === 'admin/form/logo') {
                this.mdel = 'logos';
            } else if (this.formsType === 'admin/form/visitCards') {
                this.mdel = 'visit_cards';
            } else if (this.formsType === 'admin/form/tracet') {
                this.mdel = 'tracets';
            } else if (this.formsType === 'admin/form/officeSet') {
                this.mdel = 'office_sets';
            } else if (this.formsType === 'admin/form/banner') {
                this.mdel = 'banner';
            } else if (this.formsType === 'admin/form/poster') {
                this.mdel = 'poster';
            } else this.mdel = 'brochure'

            this.infos = data.payments;
            this.myDia = true;
        },
        paymentDialog(data) {
            this.payDialogInfo = data
            this.dialogPayment = true
        },
        getUserInfo() {
            this.userInfoGot = true;
            this.$modal.showLoading();
            this.requestApiGet('userInfo')
                .then(res => {
                    this.$modal.hideLoading();
                    let response = res.data.data
                    console.log(response.status)
                    if (response.status == 'accept') {
                        this.userValid = true
                        this.statusBadge = 'accept'
                    } else if (response.status == 'reject') {
                        this.isRejected = true
                        this.userValid = false
                        this.statusBadge = 'reject'
                        let _this = this;
                        this.$modal.error('اطلاعات تکمیلی نیاز به ویرایش دارد', 'اطلاعات شما دارای مشکل میباشد',
                            undefined,
                            {},
                            [
                                {
                                    text: "رفتن به صفحه تکمیل اطلاعات",
                                    onClick() {
                                        _this.$router.push({path: "/company-register"});
                                    }
                                }
                            ]
                        )
                    } else if (response.status == 'pending') {
                        this.isPending = true
                        this.userValid = false
                        this.statusBadge = 'pending'
                        this.$modal.warning('در انتظار تایید اطلاعات',
                            'در مرحله در انتظار تایید توسط پشتیبانی شما قادر به ثبت بیلبورد نمیباشید.')
                    } else {
                        this.userValid = false
                        this.statusBadge = ''
                        let _this = this;
                        this.$modal.info('اطلاعات خود را تکمیل کنید',
                            'تا زمانی که اطلاعات خود را تکمیل نکنید قادر به ثبت بیلبورد نمیباشید.',

                            undefined,
                            {},
                            [
                                {
                                    text: "تکمیل اطلاعات",
                                    onClick() {
                                        _this.$router.push({path: "/company-register"});
                                    }
                                }
                            ]
                        )
                    }
                })
                .catch(res => {
                    this.$modal.hideLoading();
                })
        },
        getStatusBadge(status) {
            let text = status;
            let color = 'light'

            switch (status) {
                case "pending":
                    text = 'در انتظار تایید';
                    color = 'warning'
                    break;


                case "accept":
                    text = 'منتظر پرداخت';
                    color = 'info'
                    break

                case "reject":
                    text = 'رد شده';
                    color = 'danger'
                    break

                case "disable":
                    text = 'مسدود';
                    color = 'light'
                    break
            }

            return `<span class="badge badge-${color}">${text}</span>`;
        },
        selectAll(c) {
            window.Vue.$emit("selectedAllCheckbox", c);
        },
        change(data, checked) {
            if (checked) {
                this.selectedRows.push(data.id);
            } else {
                let index = this.selectedRows.indexOf(data.id)
                this.selectedRows = [
                    ...this.selectedRows.slice(0, index),
                    ...this.selectedRows.slice(index + 1, this.selectedRows.length)
                ]

            }
            window.document.querySelector("#select_all").checked = this.selectedRows.length == this.userInfo.data.length

        },
        getSites(url = this.url, params = this.tableProps) {
            this.loading = true;
            this.requestApiGet(url, params).then(response => {
                this.loading = false
                if (this.formsType === 'admin/form/all') {
                    this.userInfo = response.data.status;
                } else this.userInfo = response.data
            }).finally(() => {
                this.loading = false;
                if (!this.userInfoGot) {
                    // this.getUserInfo();
                }
            })
        },
        reloadTable(params) {
            this.getSites(this.url, params)
        },
        actions(data, type) {
            this[type](data)
        },
        show(data) {
            this.type = data.type
            this.myID = data.id;
            this.infos = data
            this.showDialog = true;
        },
    },
    computed: {
        isMobile() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                    this.getSites(this.url);
                    return true
                case 'sm':
                    this.getSites(this.url);
                    return true
                case 'md':
                    this.getSites(this.url);
                    return false
                case 'lg':
                    this.getSites(this.url);
                    return false
                case 'xl':
                    this.getSites(this.url);
                    return false
            }
        },
    },

}
</script>

<style scoped>

</style>